import type { ReactNode } from 'react';

import { CHALLENGE_WIDGET, CHALLENGE_WIDGET_TEXT } from '../../../constants';
import { ChallengeProgressBar } from '../ChallengeProgressBar/ChallengeProgressBar';

import styles from './ChallengeWideWidget.module.scss';

interface ChallengeWideWidgetProps {
  progressPercentage: number;
  target: number;
  current: number;
  timer?: ReactNode;
}

export function ChallengeWideWidget(props: ChallengeWideWidgetProps) {
  const { progressPercentage, target, current, timer } = props;
  return (
    <div className={styles.container}>
      <div className={styles.imgContainer}>
        <img alt="" className={styles.img} src={CHALLENGE_WIDGET} />
        <img alt="" className={styles.imgText} src={CHALLENGE_WIDGET_TEXT} />
      </div>
      <div className={styles.content}>
        <ChallengeProgressBar extended current={current} progressPercentage={progressPercentage} target={target} />
        {timer}
      </div>
    </div>
  );
}
